<template>
    <div>
        <dsh-modal
            v-model="showModal"
            :propsObj="sheetPrintModalPropsObj"
            class="sheetPrintModal"
        >
            <div class="sheetPrintModal-content">
                <div
                    id="sheetUpdatePrintContent"
                    class="print"
                >
                    <dsh-form
                        :canEdit="false"
                        :formData="formData"
                        :formList="curScreenFormList"
                    ></dsh-form>
                </div>
                <div class="bri-footer">
                    <Button
                        type="default"
                        @click="cancelShowtPrintModal"
                    >取消</Button>
                    <Button
                        type="primary"
                        v-print="printObj"
                    >确认打印</Button>
                </div>
            </div>
        </dsh-modal>
    </div>
</template>

<script>
    export default {
        name: "sheetPrintModal",
        props: {
            formData: Object,
            curScreenFormList: Array,
            sheetPrintModalPropsObj: Object,
            value: Boolean,
            printObj: Object
        },
        data () {
            return {
            };
        },
        computed: {
            showModal: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit("input", val);
                }
            }
        },
        created () {
            this.init();
        },
        methods: {
            // 初始化
            init () {},
            cancelShowtPrintModal () {
                this.$emit("input", false);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/operation/sheetPrintModal.vue